import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import Head from "next/head";

function getHref(category, query, skip, limit) {
    return `/blogzoeken?query=${query || ""}&category=${
        category || ""
    }&skip=${skip}&limit=${limit}`;
}

export function getUrlMask(category, query, skip, limit) {
    // if skip === 0 we are on page 0, where we don't want to append the page subdirectory to the url, as
    // the category should be page 0. With the category always defaulting to "nieuws", the second return of
    // the if/else can't happen, but for the sake of edge cases we leave it in.
    if (query) {
        if (category) {
            return skip === 0
                ? `/blog/${category}`
                : `/blog/${category}/page/${skip / limit}?query=${query}`;
        }

        return `/blog/search?query=${query}&skip=${skip}&limit=${limit}`;
    }

    return skip === 0 ? `/blog/${category}` : `/blog/${category}/page/${skip / limit}`;
}

function getListItem(skip, limit, total, query, category, page) {
    if (page * limit >= 0 && page * limit < total) {
        const label = skip === page * limit ? "..." : page;
        const mask = getUrlMask(category, query, page * limit, limit);
        const href = getHref(category, query, page * limit, limit);

        return {
            mask,
            href,
            label
        };
    }

    return null;
}

function getPagination(skip, limit, total, query, category) {
    const listItems = [];
    const startPage = (skip - 4 * limit) / limit;
    const lastPage = (skip + 5 * limit) / limit;
    for (let i = startPage; i < lastPage; i += 1) {
        const li = getListItem(skip, limit, total, query, category, i);
        if (li) {
            listItems.push(
                <li key={`li-${i}`}>
                    <a href={li.mask}>{li.label}</a>
                </li>
            );
        }
    }

    return listItems;
}

const Pagination = ({ skip, limit, total, query, category }) => {
    const listItems = getPagination(skip, limit, total, query, category);
    const baseParams = [skip, limit, total, query, category];
    const prev = getListItem(...baseParams, (skip - 1 * limit) / limit);
    const next = getListItem(...baseParams, (skip + 1 * limit) / limit);

    return (
        <>
            <Head>
                {prev && <link rel="prev" href={prev.mask} />}
                {next && <link rel="next" href={next.mask} />}
            </Head>
            <div className="results__pagination">
                <ul className="results__pagination__list">
                    {skip > 0 && (
                        <li>
                            <a href={getUrlMask(category, query, 0, limit)}>«</a>
                        </li>
                    )}
                    {listItems}
                    {skip + limit < total && (
                        <li>
                            <a href={getUrlMask(category, query, total - (total % limit), limit)}>
                                »
                            </a>
                        </li>
                    )}
                </ul>
            </div>
        </>
    );
};

Pagination.propTypes = {
    skip: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    query: PropTypes.string,
    category: PropTypes.string
};

Pagination.defaultProps = {
    query: null,
    category: null
};

export default Pagination;
